import { render } from "./fb4.vue?vue&type=template&id=f106fdd2&scoped=true"
import script from "./fb4.vue?vue&type=script&lang=js"
export * from "./fb4.vue?vue&type=script&lang=js"

import "./fb4.vue?vue&type=style&index=0&id=f106fdd2&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f106fdd2"]])

export default __exports__